import { definePanel } from '@/app/definePanel';
import { RuleFlowIcon } from '@/components/occurra/icons/RuleFlowIcon';

export default definePanel({
    id: 'rule_flow',
    title: 'Rules (experimental)',
    icon: RuleFlowIcon,
    // The scene takes the room the row has: a wider stage shows more of the flow.
    width: { min: 720, default: 960, max: Infinity, fill: true },
    modes: ['settings'],
    themes: 'any',
    // Beside the Rules panel in the rail.
    order: 3.61,
    // The panel draws its own header, with the flow name and the flows menu.
    isHeaderless: true,
    // ruleId lives in this panel's local props, as in the Rules panel.
    urlSyncedProps: [],
});
